import { render, staticRenderFns } from "./roadshow-taiwan.vue?vue&type=template&id=5405bb32"
import script from "./roadshow-taiwan.vue?vue&type=script&lang=js"
export * from "./roadshow-taiwan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports